import { useRef, useState, useEffect } from 'react';
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Modal, Form, Select,Popconfirm,message } from 'antd';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import { useLocation } from 'react-router-dom';



const DepartmentCreation = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [open, setOpen] = useState(false);
  const [departmentValue, setDepartmentValue] = useState();
  const [roleValue, setRoleValue] = useState('');
  const [data, setData] = useState([]);
  const [subData, setSubData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();
  const [recordId, setRecordId] = useState(null);
  const [formType, setFormType] = useState('');
  const [isDept, setIsDept] = useState(false);
  const [error,setError] = useState();

  const searchInput = useRef(null);
  const { Option } = Select;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);


  useEffect(() => {
    fetchMenuData();

    const paramValue = searchParams.get('add');
    const paramSubValue = searchParams.get('sub');

    if (paramSubValue) {
      paramSubValue ? showModal('addSubItem') : setOpen(false);
    } else {
      paramValue ? showModal('addItem') : setOpen(false)
    }

  }, []);

  const fetchMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/category`)
      .then(response => {
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));
        setData(modifiedResponse);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });

    axios
      .get(`${process.env.REACT_APP_API_URL}/sub_category`)
      .then(response => {
        const modifiedResponseSub = response.data.map(item => ({
          ...item,
          key: item.uuid,
        }));

        const filteredResponse = modifiedResponseSub.filter(obj => obj.name !== "all");

        setSubData(filteredResponse);
      })
      .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
  };



  const onFinish = values => {

    values.categoryId = departmentValue;

    if (isEdit) {

      // Update existing menu item
      axios
        .patch(`${process.env.REACT_APP_API_URL}/${isDept ? 'category' : 'sub_category'}/${recordId}`, values)
        .then(response => {
          fetchMenuData(); // Refresh the data after successful update
          message.success('Edited Successfully!');
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000);
        });
    } else {
      // Create new menu item
      axios
        .post(`${process.env.REACT_APP_API_URL}/${formType === 'department' ? 'category' : 'sub_category'}`, values)
        .then(response => {
          fetchMenuData(); // Refresh the data after successful creation
          message.success('Created Successfully!');
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000);
        });
    }

    handleCancel();
  };


  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
    setIsDept(false);
    setIsEdit(false);
  };

  const onChange = checked => {
    setLoading(!checked);
  };


  const handleOk = () => {
    setIsDept(false);
    setIsEdit(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const handleCancel = () => {
    setIsDept(false);
    setIsEdit(false);
    form.resetFields();
    setSelectedItemId(null);
    setSelectedRowData(null)
    setOpen(false);
  };

  const paginationConfig = {
    pageSize: 6,
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={e => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columnsDept = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '20%',
      key: 'action',
      ...getColumnSearchProps('action'),
      sorter: (a, b) => a.action.length - b.action.length,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEditDept(record)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this category/sub-category?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>

        </span>
      ),
    },
  ];

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '20%',
      key: 'action',
      ...getColumnSearchProps('action'),
      sorter: (a, b) => a.action.length - b.action.length,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this category/sub-category?"
            onConfirm={() => handleDeleteSub(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];





  const handleDelete = record => {
    axios.delete(`${process.env.REACT_APP_API_URL}/category/${record.uuid}`)
      .then(response => {
        fetchMenuData(); // Refresh the data after successful deletion
        message.success('Deleted Successfully!');
      })
      .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
  };

  const handleDeleteSub = record => {
    axios.delete(`${process.env.REACT_APP_API_URL}/sub_category/${record.uuid}`)
      .then(response => {
        fetchMenuData(); // Refresh the data after successful deletion
        message.success('Deleted Successfully!');
      })
      .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
  };


  //// Onchange for Icon type selection

  const handleChange = (value) => {
    setDepartmentValue(value)
  };

  //// Onchange for menu type selection

  const handleChangeType = (value) => {
    setRoleValue(value)
  };

  const showModal = (name) => {
    name === 'addItem' ? setFormType('department') : setFormType('subDepartment');
    form.resetFields();
    setIsEdit(false);
    setSelectedRowData(null)
    setSelectedItemId(null);
    form.setFieldsValue({
      name: null
    });

    setOpen(true);
    // Clear the selected item ID
  };

  const handleEditDept = (record) => {
    setIsDept(true);
    form.resetFields();
    setIsEdit(true);
    setSelectedItemId(record.uuid);
    setRecordId(record.uuid);
    setSelectedRowData(record);
    form.setFieldsValue({
      name: record.name
    });
    setOpen(true);

  };

  const handleEdit = (record) => {
    setIsDept(false);
    form.resetFields();
    setIsEdit(true);
    setSelectedItemId(record.uuid);
    setRecordId(record.uuid);
    setSelectedRowData(record);
    form.setFieldsValue({
      name: record.name,
      categoryId: record.categoryId
    });
    setOpen(true);

  };

  return (
    <div className="depSubDept">
       {error && <div className='errorApi'>{error}</div>}
      <div>
        <div className="tableTitle">
          <h3>All Categories</h3>
          <Button type="primary" name='addItem' onClick={() => showModal('addItem')}>
            Add Category
          </Button>
        </div>
        <Table columns={columnsDept} dataSource={data} />
      </div>

      <div>
        <div className="tableTitle">
          <h3>All Sub-Categories</h3>
          <Button type="primary" name='addSubItem' onClick={() => showModal('addSubItem')}>
            Add Sub-Category
          </Button>
        </div>
        <Table columns={columns} dataSource={subData} />
      </div>

      <Modal
        open={open}
        title={formType === 'department' ? 'Add Category' : 'Add Sub-Category'}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Return
          </Button>,
          <Button key="submit" type="primary" loading={loading} htmlType="submit" form="menuForm">
            Submit
          </Button>
        ]}
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}

          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          id="menuForm" // Add an ID to the form
          layout=''
        >
          <Form.Item
            label={formType === 'department' ? 'Category Name ' : 'Sub-Category Name '}
            name="name"
            rules={[
              {
                required: true,
                message: 'Please input Category name!',
              },
            ]}
          >
            <Input />

          </Form.Item>

          {(formType === 'department') || (isDept) ? '' : <Form.Item
            label='Select Category'
            name="categoryId"
            rules={[
              {
                required: true,
                message: 'Please select category name!',
              },
            ]}
          >

            <Select defaultValue="Select an option" onChange={handleChange}
              allowClear>
              {data.map(item => (
                <Option key={item.uuid} value={item.uuid}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </Form.Item>}


        </Form>
      </Modal>
    </div>
  );
};

export default DepartmentCreation;
